<template>
    <div class="accountRecord">
        <div class="wrap-flex wrap-flex-v">
            <div class="tab">
                <div :class="{ 'active': tab == 2, 'tab-item': true }" @click="changeTab(2)">
                    <span class="tab-content">交易记录</span>
                </div>
                <!---->
                <div :class="{ 'active': tab == 1, 'tab-item': true }" @click="changeTab(1)">
                    <span class="tab-content">充值/提现记录</span>
                </div>
                <!-- <div :class="{ active: tab == 'D', 'tab-item': true }" @click="changeTab(2)">
                    <span class="tab-content">提现记录</span>
                </div> -->
            </div>
            <div class="flex page-loadmore-wrapper" v-if="tab == 2" ref="wrapper">
                <mt-loadmore :top-method="loadTop" @translate-change="translateChange" @top-status-change="handleTopChange" :bottom-method="loadBottom" @bottom-status-change="handleBottomChange" :bottom-all-loaded="expense.total_page == expense.page_num" ref="loadmore">
                    <ul v-if="expense.listArr.length > 0" class="page-loadmore-list">
                        <li class="pull-hint">下拉刷新列表</li>
                        <li v-for="(record,index) in expense.listArr" :key="index" class="item item-db record-item">
                            <h3 class="fz-num">
                                <span class="l-con">{{record.trans_desc}}</span>
                                <span class="r-con">{{record.total_amount | fmoney}}</span>
                            </h3>
                            <p class="text-secondary create-date color-description">
                                <!-- <span class="l-con">{{record.error_msg}}</span> -->
                                <span class="r-con">{{record.trade_time}}</span>
                            </p>
                        </li>
                        <li v-if="expense.total_page == expense.page_num" class="pull-hint">没有更多记录了</li>
                        <li v-else class="pull-hint">上拉加载更多</li>
                    </ul>
                    <div class="nothing" v-else>
                        <!-- <div class="pull-hint">下拉刷新列表</div> -->
                        <span class="icon-w-search"></span>
                        <p class="color-description" style="margin-top: 15px;">暂无记录</p>
                    </div>
                    <div slot="top" class="mint-loadmore-top">
                        <span v-show="topStatus !== 'loading'" :class="{ 'is-rotate': topStatus === 'drop' }">↓</span>
                        <span v-show="topStatus === 'loading'">
                            <mt-spinner type="snake"></mt-spinner>
                        </span>
                    </div>
                    <div slot="bottom" class="mint-loadmore-bottom">
                        <span v-show="bottomStatus !== 'loading'" :class="{ 'is-rotate': bottomStatus === 'drop' }">↑</span>
                        <span v-show="bottomStatus === 'loading'">
                            <mt-spinner type="snake"></mt-spinner>
                        </span>
                    </div>
                </mt-loadmore>
                <!-- <div class="loading active">
                    <i class="icon-w-loading"></i>正在加载中
                </div>
                <div class="loading active">
                    没有更多记录了
                </div> -->
            </div>

            <div class="flex page-loadmore-wrapper" v-if="tab == 1" ref="wrapper">
                <mt-loadmore :top-method="loadTop" @translate-change="translateChange" @top-status-change="handleTopChange" :bottom-method="loadBottom" @bottom-status-change="handleBottomChange" :bottom-all-loaded="charge.total_page == charge.page_num" ref="loadmore">
                    <ul v-if="charge.listArr.length > 0" class="page-loadmore-list">
                        <li class="pull-hint">下拉刷新列表</li>
                        <li v-for="(record,index) in charge.listArr" :key="index" class="item item-db record-item">
                            <h3 class="fz-num">
                                <span class="l-con">{{record.trans_desc}}</span>
                                <span class="r-con">{{record.total_amount | fmoney}}</span>
                            </h3>
                            <p class="text-secondary create-date color-description">
                                <!-- <span class="l-con">{{record.error_msg}}</span> -->
                                <span class="r-con">{{record.trade_time}}</span>
                            </p>
                        </li>
                        <li v-if="charge.total_page == charge.page_num" class="pull-hint">没有更多记录了</li>
                        <li v-else class="pull-hint">上拉加载更多</li>
                    </ul>
                    <div class="nothing" v-else>
                        <!-- <div class="pull-hint">下拉刷新列表</div> -->
                        <span class="icon-w-search"></span>
                        <p class="color-description" style="margin-top: 15px;">暂无记录</p>
                    </div>
                    <div slot="top" class="mint-loadmore-top">
                        <span v-show="topStatus !== 'loading'" :class="{ 'is-rotate': topStatus === 'drop' }">↓</span>
                        <span v-show="topStatus === 'loading'">
                            <mt-spinner type="snake"></mt-spinner>
                        </span>
                    </div>
                    <div slot="bottom" class="mint-loadmore-bottom">
                        <span v-show="bottomStatus !== 'loading'" :class="{ 'is-rotate': bottomStatus === 'drop' }">↑</span>
                        <span v-show="bottomStatus === 'loading'">
                            <mt-spinner type="snake"></mt-spinner>
                        </span>
                    </div>
                </mt-loadmore>
            </div>

            <div class="flex page-loadmore-wrapper" v-if="tab == 'D'" ref="wrapper">
                <mt-loadmore :top-method="loadTop" @translate-change="translateChange" @top-status-change="handleTopChange" :bottom-method="loadBottom" @bottom-status-change="handleBottomChange" :bottom-all-loaded="cash.total_page == cash.page_num" ref="loadmore">
                    <ul v-if="cash.listArr.length > 0" class="page-loadmore-list">
                        <li class="pull-hint">下拉刷新列表</li>
                        <li v-for="(record,index) in cash.listArr" :key="index" class="item item-db record-item">
                            <h3 class="fz-num">
                                <span class="l-con">{{record.trans_name}}</span>
                                <span class="r-con">- {{record.amount | abs | fmoney}}</span>
                            </h3>
                            <p class="text-secondary create-date color-description">
                                <!-- <span class="l-con">{{record.error_msg}}</span> -->
                                <span class="r-con">{{record.trade_time}}</span>
                            </p>
                        </li>
                        <li v-if="cash.total_page == cash.page_num" class="pull-hint">没有更多记录了</li>
                        <li v-else class="pull-hint">上拉加载更多</li>
                    </ul>
                    <div class="nothing" v-else>
                        <!-- <div class="pull-hint">下拉刷新列表</div> -->
                        <span class="icon-w-search"></span>
                        <p class="color-description" style="margin-top: 15px;">暂无记录</p>
                    </div>
                    <div slot="top" class="mint-loadmore-top">
                        <span v-show="topStatus !== 'loading'" :class="{ 'is-rotate': topStatus === 'drop' }">↓</span>
                        <span v-show="topStatus === 'loading'">
                            <mt-spinner type="snake"></mt-spinner>
                        </span>
                    </div>
                    <div slot="bottom" class="mint-loadmore-bottom">
                        <span v-show="bottomStatus !== 'loading'" :class="{ 'is-rotate': bottomStatus === 'drop' }">↑</span>
                        <span v-show="bottomStatus === 'loading'">
                            <mt-spinner type="snake"></mt-spinner>
                        </span>
                    </div>
                </mt-loadmore>
            </div>
        </div>
    </div>
</template>

<script>
import { Checklist } from 'mint-ui';
import { Indicator } from 'mint-ui';
import { Toast } from 'mint-ui';
import { Get, Post } from '@/utils/http';
import { Cell } from 'mint-ui';
import moment from 'moment'
export default {
    name: 'Recharge',
    data() {
        return {
            wallet_id: '',
            tab: 2,
            topStatus: '',
            bottomStatus: '',
            isPullDown: false,
            isPullUp: false,
            expense: {
                offset: 0,
                limit: 10,
                total: 0,
                listArr: [],
                total_page: 0,
                page_num: 0
            },
            charge: {
                offset: 0,
                limit: 10,
                total: 0,
                listArr: [],
                total_page: 0,
                page_num: 0
            },
            // cash: {
            //     offset: 0,
            //     limit: 10,
            //     total: 0,
            //     listArr: [],
            //     total_page: 0,
            //     page_num: 0
            // },
        }
    },
    computed: {

    },
    beforeMount() {

    },
    mounted() {
        this.wallet_id = this.$route.params.wallet_id;
        this.getList()
    },
    filters: {

    },
    methods: {
        loadTop() {
            console.log('loadTop')
            // expenseLoading = true
            // console.log('loadTop')
            // this.$refs.loadmore.onTopLoaded();
            // setTimeout(() => {
            //     // let firstValue = this.list[0];
            //     // for (let i = 1; i <= 10; i++) {
            //     //     this.list.unshift(firstValue - i);
            //     // }
            //     this.$refs.loadmore.onTopLoaded();
            // }, 5000);

            let  currentObj;
            if( this.tab == 2){
                currentObj =  this.expense;
            }else if( this.tab == 1){
                currentObj =  this.charge;
            }else{
                // currentObj =  this.cash;
            }



            this.isPullDown = true
            currentObj.offset = 0
            // console.log(currentObj)
            // currentObj.listArr = []
            this.getList()
        },
        handleTopChange(status) {
            // this.moveTranslate = 1;
            // console.log('topStatus:' + this.topStatus)
            this.topStatus = status;
        },
        translateChange(translate) {
            // const translateNum = +translate;
            // this.translate = translateNum.toFixed(2);
            // this.moveTranslate = (1 + translateNum / 70).toFixed(2);
        },
        handleBottomChange(status) {
            this.bottomStatus = status;
        },
        loadBottom() {
            // setTimeout(() => {
            //     this.expenseAllLoaded = true;
            //     this.$refs.loadmore.onBottomLoaded();
            // }, 5000);
            this.isPullUp = true
            this.getList()
        },
        getList() {
            const url = '/v1/person/wallet/trans';

            let  currentObj;
            if( this.tab == 2){
                currentObj =  this.expense;
            }else if( this.tab == 1){
                currentObj =  this.charge;
            }else{
                // currentObj =  this.cash;
            }

            const params = {
                wallet_id: this.wallet_id,
                trans_type: this.tab,
                start_date: moment().subtract(1, "years").format("YYYY-MM-DD"),
                end_date: moment().format("YYYY-MM-DD"),
                offset: currentObj.offset,
                limit: currentObj.limit,
                stat: true
            };
            Indicator.open();
            Post(url, params).then((res) => {
                Indicator.close();
                if (this.isPullDown) {
                    this.isPullDown = false
                    currentObj.listArr = []
                    this.$refs.loadmore.onTopLoaded();
                }
                if (this.isPullUp) {
                    this.isPullUp = false
                    this.$refs.loadmore.onBottomLoaded();
                }
                try {
                    currentObj.total_page = res.total_page
                    currentObj.page_num = res.page_num
                    currentObj.total = res.total
                    currentObj.offset = (res.page_num - 1) * res.page_limit + res.list.length
                    currentObj.listArr = currentObj.listArr.concat(res.list)
                } catch (e) {
                    console.error(e)
                }
                // if (this.tab == 2) {
                //     this.expense = currentObj
                // } else {
                //     this.cash = currentObj
                // }
            }).catch((error) => {
                Indicator.close();
                Toast({
                    message: "code:" + error.code + " message:" + error.msg,
                    duration: 3000
                });
            })
        },
        changeTab(index) {
            let currentObj;
            switch(index){
                case 2:
                    this.tab = 2;
                    currentObj = this.expense;
                    break;
                case 1:
                    this.tab = 1;
                    currentObj = this.charge;
                    break;
                // case 2:
                //     this.tab = 'D';
                //     currentObj = this.cash;
                //     break;
            }
            currentObj.listArr = []
            currentObj.offset = 0
            this.getList()
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped  lang="less">
.accountRecord {
  height: 100%;
  overflow: hidden;
}
.tab {
  flex: 0 0 auto;
  display: flex;
  display: -webkit-flex;
  position: relative;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  -moz-align-items: center;
  align-items: center;
}
.accountRecord .tab {
  background: #fafafa;
  color: #66748a;
}
.board:before,
.list:before,
.otpLine .otp:before,
.pop-content:before,
.tab:before,
.wrap-table:before {
  content: "";
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  height: 200%;
  width: 200%;
  pointer-events: none;
  -webkit-transform: scale(0.5);
  -moz-transform: scale(0.5);
  transform: scale(0.5);
  -webkit-transform-origin: 0 0;
  -moz-transform-origin: 0 0;
  transform-origin: 0 0;
  border-top: 1px solid #f1f1f1;
  border-right: 0 solid #f1f1f1;
  border-bottom: 0 solid #f1f1f1;
  border-left: 0 solid #f1f1f1;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  -o-border-radius: 0;
  border-radius: 0;
}
.tab .tab-item {
  display: block;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -moz-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 0.38rem;
  line-height: 0.38rem;
  text-align: center;
}
.accountRecord .tab .tab-item.active .tab-content,
.accountRecord
  .tab
  .wrap-progress.step-1
  .tab-item.progress-item:first-child
  .tab-content,
.accountRecord
  .tab
  .wrap-progress.step-2
  .tab-item.progress-item:nth-child(2)
  .tab-content,
.accountRecord
  .tab
  .wrap-progress.step-3
  .tab-item.progress-item:nth-child(3)
  .tab-content,
.accountRecord
  .tab
  .wrap-progress.step-4
  .tab-item.progress-item:nth-child(4)
  .tab-content,
.wrap-progress.step-1
  .accountRecord
  .tab
  .tab-item.progress-item:first-child
  .tab-content,
.wrap-progress.step-2
  .accountRecord
  .tab
  .tab-item.progress-item:nth-child(2)
  .tab-content,
.wrap-progress.step-3
  .accountRecord
  .tab
  .tab-item.progress-item:nth-child(3)
  .tab-content,
.wrap-progress.step-4
  .accountRecord
  .tab
  .tab-item.progress-item:nth-child(4)
  .tab-content {
  display: inline-block;
  height: 100%;
  border-bottom: 2px solid #3b8aff;
}
.nothing {
  width: 100%;
  padding: 1.2rem 0.15rem 0;
  text-align: center;
}
.icon-w-coin,
.icon-w-search {
  background-position: 0 0;
  background-repeat: no-repeat;
  background-size: contain;
  display: inline-block;
}
.icon-w-search {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAABwCAMAAADMrGUfAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAACBUExURUxpcZeluZikuZ6svpiluZikuZmnuZmpvZekuaS4x5mnu5iluZmmupqmupmmupmluZiluZiluZiluZunu5ilufr6+pekuPf4+erv99Xl+2wj/nuw/VKY/rPQ/OXo7EiS/qKuwPLz9sLZ+5nc/KTI/MDI1LrC0K23x9Xa4Yy6/cjP2cgaA7AAAAAVdFJOUwDc5RN/9mIdmwcqvlY1SG/Np4v+7rvbqk0aaaqisurbvgje7vpnl6owebuhs+8yoskowp//D3yTsMUCvNVNOK9wP7gn7Dm55M5kmi4W77CXDLrQ1SAUYNAFrqxhMlVnELhSQVtMBh8C9eGh5kvhUlcA4f1DHRQpZCEEBLyH0xoyuPTlSkch755GIElGFy10bzQD3iR6iatOR6bdyabqpjwy585qpimRzAQw5cp4HRkDcKWSuSS6vm1vMsnU5fXFvbtYoskMsM1rd4xkkq1AH45PBhFLRm78T1Iw/CJTdfUzs2lyySyrO40PHSK5WdNRNP7ZwV/M+KshNeovJs3UksmCwJyO7DZc/T9kZEIy8VF/QjLLmmPXjDnqz1F/jvpz1J/x58DSQlshRLFDTbK1rEiBKyiRJS3q6wYS1PvTJqU03Zz2NS4NXUogNiMC8X6TXGGzj4FEEsKVagMc0uQO6QHAVkWTWQrU3amypsirqsyLNafe1KBYYsmsFRy3uDVty7LZZSlNs3VR5Rk+2h6bwcljvauofddel0x2pshtlvqaiiou6ps2hjglfnl2azlavjv8pn7mr34idwrumm0leu8gsva2qgqt7tsknqd6bs2bpadpuuyvaailijpgglswrdklrejtd6jmvhbe6otrnpatjbusjmkmyijlbhsuscysirso717qhexhfmulqa4krvk0mijgxro3hdlykpzri+s+HZ+O+j5TMStHuJJdznTUBESQEE5J0pzHyCjqeHr89uwFMpuZrNiNkbF/b8AWQMb9I89Gyc7rJO3zkKfJCOAFq9JRsqZJKBBhZHSUrD0PkJGnZcRTleMnQ99PhVw0+xs2K9b9DvI0uOvjbmPAd+l1/ReSGV7qdTHGlaJJ90JSmsvCVTrqIexV6tuv6V7Fkhtt7FbnzGRLQbnz0oW/ZCShXQRlTxfiLX/7wYPtkm3cq+ILtb7N43415P0Nj/m2oLrxvS4otwMipoNVwStFqsHLxnPeF0Z2eGIsHA1hFTEriJlePem6LXltNVASv1R+Y6l/Yfepam6lzHJ22gusLJGNhQe82E+Lsv3Uku4KVqBiqc9+dOKtVr6oCY9HujYmO5f5uV3v2gabmJZ2TYzHXRYgVEW10wrEFx6zMiQqzg1vz+glfm/PWAsMS08QmxpiQ326sdn2VH82nmbIe3phDYYbAMTH04YTbjenYwwQfJ3ljTA2W1SHsXBsvmFc1zH7S2znRumAPVw5wlo11QmDFd8zCB31YaDApTSEzulMfei3OR5/EWWiSR2bYKC+/o8nPN/sDTo/UWXMiHucVvm8chPM9d+vnDvR9Nsh3f2eZtSuB3zsM9Vcn/9qbp7rfzv1zHP9fw6+7yrzyhr+74k2g/9/5fnxy/CeXll+ZD/+cLjnhXxMcR/t9luXXJ9eOWwRfqfgMD3f++HJdM13flcm/gKwLJw99g9FoAAAAABJRU5ErkJggg==);
  width: 54px;
  height: 56px;
}
.color-description {
  color: #97a4b8 !important;
}
.wrap-flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -moz-flex;
  display: -ms-flexbox;
  display: flex;
}
.wrap-flex.wrap-flex-v {
  -webkit-box-direction: normal;
  -webkit-box-orient: vertical;
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100%;
}
.wrap-flex .flex {
  flex: 1 1 auto;
  overflow-y: auto;
  /* -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch; */
  -webkit-touch-callout: none;
  -webkit-overflow-scrolling: touch;
}
.list {
  position: relative;
  background-color: #fff;
  overflow: hidden;
}
.accountRecord .list {
  color: #97a4b8;
}
.board:before,
.list:before,
.otpLine .otp:before,
.pop-content:before,
.tab:before,
.wrap-table:before {
  content: "";
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  height: 200%;
  width: 200%;
  pointer-events: none;
  -webkit-transform: scale(0.5);
  -moz-transform: scale(0.5);
  transform: scale(0.5);
  -webkit-transform-origin: 0 0;
  -moz-transform-origin: 0 0;
  transform-origin: 0 0;
  border-top: 1px solid #f1f1f1;
  border-right: 0 solid #f1f1f1;
  border-bottom: 0 solid #f1f1f1;
  border-left: 0 solid #f1f1f1;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  -o-border-radius: 0;
  border-radius: 0;
}
.item {
  padding-left: 0.15rem;
  padding-right: 0.15rem;
  position: relative;
  overflow: visible;
  display: block;
}
.item-db {
  padding-right: 0.15rem;
}
.item-db,
.item-db-icon {
  padding-top: 0.12rem;
  padding-bottom: 0.12rem;
}
.record-item {
  transition: all 2s;
  display: inline-block;
  width: 100%;
  box-sizing: border-box;
  .create-date {
    line-height: 1.4;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
    .l-con {
      flex: 1 1 auto;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .r-con {
      flex: 0 0 auto;
      margin-left: 10px;
      text-align: right;
    }
  }
}
.fz-num {
  font-size: 18px !important;
  line-height: 1.4;
  display: -webkit-flex;
  display: flex;
  .l-con {
    flex: 1 1 auto;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .r-con {
    flex: 0 0 auto;
    margin-left: 10px;
    min-width: 60px;
    text-align: right;
  }
}
.accountRecord .list .fz-num {
  color: #66748a;
}
.f-rt {
  float: right;
}
.bar-card-inset,
.board .board-title,
.btn-show,
.credit-tem,
.pop-content .title,
.pop-msg-lg,
.pop-msg-md,
.text-secondary,
.wrap-table {
  font-size: 14px;
  color: #66748a;
}
.color-description {
  color: #97a4b8 !important;
}
.f-rt {
  float: right;
}
.board:after,
.btn-show:after,
.credit-tem .tem-credit:after,
.item:not(:last-child):after,
.list:after,
.tab:after {
  content: "";
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  height: 200%;
  width: 200%;
  pointer-events: none;
  -webkit-transform: scale(0.5);
  -moz-transform: scale(0.5);
  transform: scale(0.5);
  -webkit-transform-origin: 0 0;
  -moz-transform-origin: 0 0;
  transform-origin: 0 0;
  border-top: 0 solid #f1f1f1;
  border-right: 0 solid #f1f1f1;
  border-bottom: 1px solid #f1f1f1;
  border-left: 0 solid #f1f1f1;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  -o-border-radius: 0;
  border-radius: 0;
}
.loading {
  text-align: center;
  font-size: 12px;
  color: #999;
  padding: 0.1rem 0.15rem;
  display: none;
}
.icon-w-loading {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAMAAAAOusbgAAAABGdBT…6kI7RMSIzibwerx/GBdSAxgvRccYJ0mbEC99UJCQkJCd/IPzsx+3edr4gxaaaaaelftksuqmcc);
  background-position: 0 0;
  background-repeat: no-repeat;
  background-size: contain;
  width: 16px;
  height: 16px;
  display: inline-block;
  -webkit-animation: loading-sm 1s steps(12) infinite;
  -moz-animation: loading-sm 1s steps(12) infinite;
  animation: loading-sm 1s steps(12) infinite;
  animation-fill-mode: both;
}
.loading .icon-w-loading {
  vertical-align: middle;
}
.loading.active,
.wrap-progress.step-1 .loading.progress-item:first-child,
.wrap-progress.step-2 .loading.progress-item:nth-child(2),
.wrap-progress.step-3 .loading.progress-item:nth-child(3),
.wrap-progress.step-4 .loading.progress-item:nth-child(4) {
  display: block;
}
.pull-hint {
  font-size: 12px;
  color: #999;
  text-align: center;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/Record.vue